import React from "react";

const types = {
	email: {
		regex:
			/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
		message: "Preencha um email válido",
	},
	password:{
		regex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/,
		message: 'A senha precisa ter 1 carácter maiúsculo, 1 minúsculo e 1 dígito. Com no mínimo 8 caracteres.'
	},
	number:{
		regex: /^\d+$/,
		message: 'Utilize apenas números'
	}
};

function useForm(type) {
	const [value, setValue] = React.useState("");
	const [error, setError] = React.useState(null);

	function validate(value) {
		if (type === false) return true;

		if (value.length === 0) {
			setError("Preencha um valor.");
			return false;
		}

		if (types[type] && !types[type].regex.test(value)) {
			setError(types[type].message);
			return false;
		}

		setError(null);
		return true;
	}

	function onChange({ target }) {
		if (error) validate(target.value);
		setValue(target.value);
	}

	return {
		value,
		setValue,
		onChange,
		error,
		validate: () => validate(value),
		onBlur: () => validate(value),
	};
}

export default useForm;
